import { checkParentTarget, conditions, isTouchScreen } from 'helpers'
import { MouseEvent, useEffect, useState } from 'react'
import { handleFullScreen, handlePlayPause, handleSubtitle, handleVideoElementSizeInfo } from 'redux-share/actions'
import { useAppDispatch, useAppSelector } from 'redux-share/hooks'
import { ConditionName, zIndex } from 'interfaces'
import useActiveInActive from 'helpers/hooks/useActiveInActive'
import { setShowMiniPlayer } from 'redux-share/slices/controllerSlice'
import PlayerCore from 'ui/src/components/player-core/playerCore'
import { shallowEqual } from 'react-redux'
import Image from 'next/image';
import dynamic from "next/dynamic";

const Voucher = dynamic(() => import("ui/src/components/player-components/voucher/voucher"));
const CinemaHamrahPopover = dynamic(() => import("ui/src/components/player-components/cinemaHamrahPopovers/cinemaHamrahPopovers"));
const TouchVolumeBrightness = dynamic(() => import("ui/src/components/player-components/touchVolumeBrightness/touchVolumeBrightness"));
const BackwardForward = dynamic(() => import("ui/src/components/player-components/backwardForward/backwardForward"));
const AutoPlay = dynamic(() => import("ui/src/components/player-components/autoPlay/autoPlay"));
const Gif = dynamic(() => import("ui/src/components/player-components/gif/gif"));
const CloseIcon = dynamic(() => import("ui/src/components/icon-components/closeIcon"));
const Header = dynamic(() => import("ui/src/components/mainComponent/header/header"));
const PortraitHeader = dynamic(() => import("ui/src/components/mainComponent/header/portraitHeader"));
const Main = dynamic(() => import("ui/src/components/mainComponent/main/main"));
const Footer = dynamic(() => import("ui/src/components/mainComponent/footer/footer"));
const Advertisement = dynamic(() => import("ui/src/components/player-components/ad/advertisement"));
const ContinuousPlayback = dynamic(() => import("../../../../../playerComponents/continuousPlayback/ContinuousPlayback"));
const FullScreen = dynamic(() => import("ui/src/components/player-components/fullScreen/fullScreen"));
const JustAudio = dynamic(() => import("ui/src/components/player-components/justAudio/justAudio"));

const VideoArea = () => {

  const [isRightDoubleTouched, setIsRightDoubleTouched] = useState<boolean>(false)
  const [isLeftDoubleTouched, setIsLeftDoubleTouched] = useState<boolean>(false)

    const dispatch = useAppDispatch();
    const { gif, details } = useAppSelector(({ videoData: { gif, details, recommendationList, params, videoElementSizeInfo, cinemaHamrahState } }) => ({ gif, details, recommendationList, params, videoElementSizeInfo, cinemaHamrahState }), shallowEqual);
    const { showMiniPlayer, firstPlay } = useAppSelector(({ controller: { showMiniPlayer, firstPlay, lock, isEnded, isAutoPlay } }) => ({ showMiniPlayer, firstPlay, lock, isEnded, isAutoPlay }), shallowEqual);
    useAppSelector(({ popovers: { autoPlayPopover } }) => ({ autoPlayPopover }), shallowEqual);
    useAppSelector(({ user: { videoSettings, showContinuousePlayback } }) => ({ videoSettings, showContinuousePlayback }), shallowEqual);

  const handleDoubleClick = (event: MouseEvent<HTMLDivElement>) => {
    if (!conditions(ConditionName.isPlayingAd) && !conditions(ConditionName.isTouchScreen) && !checkParentTarget(event, 'emojiButtonLeft') && !checkParentTarget(event, 'emojiButtonRight') && !checkParentTarget(event, 'menuIconLeft') && !checkParentTarget(event, 'menuIconRight')) handleFullScreen()
  }

  // --- Managing the active and inActive of elements in desktop and mobile devices --- //
  useActiveInActive(isRightDoubleTouched, isLeftDoubleTouched)

  useEffect(() => {
    const timeout = setTimeout(() => handleVideoElementSizeInfo(), 100)

    return () => clearTimeout(timeout)
  }, [showMiniPlayer])

  useEffect(() => { 
    if (conditions(ConditionName.hasSubtitles) && !conditions(ConditionName.isFirstPlay)) handleSubtitle()
  }, [firstPlay])

  return (
    <>
      {conditions(ConditionName.showMiniPlayer) && !conditions(ConditionName.isPlayingAd) && <div id='black-video-area' className='pl-relative pl-w-full pl-aspect-video pl-bg-black' />}
      <div
        id='video-area'
        style={{zIndex: conditions(ConditionName.showMiniPlayer) ? zIndex.videoPlayerInPictureInPicture : 'unset'}}
        onClick={(event) => conditions(ConditionName.playByClickPoster) && !conditions(ConditionName.isAdBlockerActivate) && handlePlayPause(event)}
        onDoubleClick={(event: MouseEvent<HTMLDivElement>) => !conditions(ConditionName.showVoucherPopup) && handleDoubleClick(event)}
        className={`!pl-bg-contain !pl-bg-center !pl-bg-no-repeat pl-h-full pl-bg-black pl-max-h-screen pl-aspect-video pl-flex pl-items-center ${conditions(ConditionName.isFullScreen) && '!pl-w-screen !pl-h-[100dvh]'} ${conditions(ConditionName.showMiniPlayer) ? '!pl-fixed !pl-bottom-[10px] !pl-right-[10px] !pl-w-[400px] !pl-h-[225px]' : 'pl-w-full pl-relative'} ${!conditions(ConditionName.isComplexPortrait) && "pl-overflow-hidden"}`}
      >
        {conditions(ConditionName.showBanner) && <div className='pl-absolute pl-w-full pl-h-full pl-flex pl-justify-center'>
          <Image src={details.banner} layout='fill'  alt="sdfdf" objectFit="contain"/>
        </div>}
        {conditions(ConditionName.showVoucherPopup) && !conditions(ConditionName.isPlayingAd) && <Voucher />}
        {conditions(ConditionName.hasCinemaHamrahState) && !conditions(ConditionName.isPlayingAd) && <CinemaHamrahPopover />}
        {conditions(ConditionName.showMiniPlayer) && !conditions(ConditionName.isPlayingAd) && <CloseIcon className='pl-w-4 pl-h-4 pl-stroke-black pl-bg-white pl-absolute pl-top-[-7px] pl-right-[-5px] pl-z-10 pl-cursor-pointer pl-rounded-full' onClick={() => dispatch(setShowMiniPlayer(undefined))} />}
        {(conditions(ConditionName.showTouchVolumeBrightness) && !conditions(ConditionName.isMiniPlayer)) && !conditions(ConditionName.isPlayingAd) &&
        <TouchVolumeBrightness />}
        {conditions(ConditionName.showBackwardForward) && !conditions(ConditionName.isPlayingAd) && (
          <div
            className={`pl-absolute pl-top-0 pl-right-0 pl-w-full pl-h-full pl-overflow-hidden pl-flex pl-items-center`}
            style={{ zIndex: (isLeftDoubleTouched || isRightDoubleTouched) ? zIndex.backwardForwardActive : zIndex.backwardForwardInActive }}>
            <BackwardForward type='touchForward' isRightDoubleTouched={isRightDoubleTouched}
                             setIsRightDoubleTouched={setIsRightDoubleTouched} />
            <BackwardForward type='touchBackward' isLeftDoubleTouched={isLeftDoubleTouched}
                             setIsLeftDoubleTouched={setIsLeftDoubleTouched} />
          </div>
        )}
        {conditions(ConditionName.isComplexPortrait) && !conditions(ConditionName.isPlayingAd) &&
        <div id='video-opacity'
             className={`pl-absolute pl-top-0 pl-h-full pl-cursor-pointer pl-w-full pl-bg-gray-800/[0.3] animate__animated ${conditions(ConditionName.isActiveElements) ? 'animate__fadeIn' : 'animate__fadeOut'}`} />}
        {conditions(ConditionName.isPlayingAd) && !conditions(ConditionName.isFirstPlay) && !conditions(ConditionName.isStaticFormat) && <Advertisement />}
        {conditions(ConditionName.isAdBlockerActivate) && !conditions(ConditionName.isStaticFormat) && (
          <div onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }} onDoubleClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
          }}
          className={`${isTouchScreen() ? 'pl-text-[13px]' : 'pl-text-[16px]'} pl-text-center pl-top-0 pl-left-0 pl-absolute pl-h-full pl-w-full pl-bg-secondary-700/[0.8] pl-backdrop-blur-[4px] pl-flex pl-items-center pl-justify-center pl-p-2 pl-z-[1000000000] pl-text-white`}>
            کاربر گرامی، برای مشاهده ویدیو، لطفا افزونه عدم نمایش تبلیغات را غیرفعال نمایید.
          </div>
        )}
        <PlayerCore />
        {conditions(ConditionName.hasContinuousPlayback) && <ContinuousPlayback />}
        {((!conditions(ConditionName.isRaw) && !conditions(ConditionName.isPlayingAd)) && !conditions(ConditionName.hasContinuousPlayback) || (conditions(ConditionName.isPlayingAd) && conditions(ConditionName.isFirstPlay))) && (
          <div id='playerElements'
               className={`pl-absolute pl-top-0 pl-right-0 pl-w-full pl-h-full ${conditions(ConditionName.showAutoPlayPopover) && 'pl-bg-black'}`}>
            <div className={`pl-flex pl-flex-col pl-justify-between pl-w-full pl-h-full`}>
              {conditions(ConditionName.showAutoPlayPopover) && !conditions(ConditionName.isPlayingAd) && <AutoPlay />}
              {conditions(ConditionName.showHeader) && !conditions(ConditionName.isPlayingAd) && <>{conditions(ConditionName.isComplexPortrait) ?
                <PortraitHeader /> : <Header />}</>}
              {((conditions(ConditionName.showMain) && !conditions(ConditionName.isPlayingAd)) && !conditions(ConditionName.hasContinuousPlayback) || (conditions(ConditionName.isPlayingAd) && conditions(ConditionName.isFirstPlay))) && <Main />}
              {conditions(ConditionName.showFooter) && !conditions(ConditionName.isPlayingAd) && <Footer />}
              {conditions(ConditionName.showGif) && !conditions(ConditionName.isPlayingAd) && <Gif gif={gif!} />}
              {conditions(ConditionName.showFullScreenIconInComplexPortrait) && !conditions(ConditionName.isPlayingAd) &&
              <div
                className={`animate__animated animate__faster ${conditions(ConditionName.isActiveElements) ? 'animate__fadeInUp' : 'animate__fadeOutDown'} pl-absolute ${conditions(ConditionName.hasMarkers) ? 'pl-bottom-8' : 'pl-bottom-3'} pl-right-4`}
                style={{ zIndex: zIndex.portraitFullScreenIcon }}
              >
                <FullScreen />
              </div>
              }
            </div>
          </div>
        )}
        {conditions(ConditionName.showAudioEqualizer) && !conditions(ConditionName.isPlayingAd) && <JustAudio />}
      </div>
    </>
  )
}

export default VideoArea